import React from 'react';
import styled from 'styled-components';
import { Checkbox } from 'antd';
import PropTypes from 'prop-types';

const CheckBoxCustom = styled(Checkbox)`
  display: flex;
  line-height: 1;
  align-items: center;
  margin: 10px;
  width: 100%;

  > span {
    &.ant-checkbox {
      top: 0;
    }

    &:not(.ant-checkbox) {
      display: flex;
      flex-direction: column;
      flex: 1;
    }
  }
`;

const CheckBoxTitle = styled.div`
  text-transform: uppercase;
`;

function CheckBoxWithSubtitle({ title, subtitle, checked, onChange }) {
  return (
    <CheckBoxCustom
      checked={checked}
      onChange={onChange}
    >
      <CheckBoxTitle>{title}</CheckBoxTitle>
      <div>{subtitle}</div>
    </CheckBoxCustom>
  );
}

CheckBoxWithSubtitle.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  checked: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default CheckBoxWithSubtitle;
